<template>
  <div class="container">
    <div class="content">
      <div class="add-new-modal">
        <h3 class="my-4 py-4" id="adding-modal-content">
          {{
            !editingMode
              ? `Dodawanie nowego modala`
              : `Edycja modala ${modalToEdit.id}`
          }}
        </h3>

        <p style="font-size: 14px; margin-bottom: 4rem">
          W celu zawinięcia tekstu w konkretnym miejscu należy dodać znacznik
          <br />
          &lt;hide&gt;
          <br />
          <br />
          W celu dodania tekstu "Lista partnerów", który będzie odnośnikiem
          otwierającym listę partneów przypisanych do modala, należy dodać
          znacznik

          <br />&lt;partners&gt;Lista partnerów&lt;/partners&gt;
        </p>

        <div>
          <button
            v-if="editingMode"
            type="button"
            class="btn btn-danger"
            @click="cancelEdition()"
          >
            Zakończ edycję bez zapisywania
          </button>
        </div>

        <div class="input-container mb-4">
          <label>Grafika</label>
          <br />
          <input type="file" @change="handleModalPicture($event)" />
          <br />
          <span class="selected-picture-error">{{ selectedPictureError }}</span>
        </div>

        <div class="input-container">
          <label>Tytuł</label>
          <html-editor
            :editorId="'titleHtmlEditor'"
            @contentchanged="handleHtmlEditorTitle($event)"
            :startContent="''"
          />
        </div>

        <div class="input-container">
          <label>Treść</label>
          <html-editor
            :editorId="'headerHtmlEditor'"
            @contentchanged="handleHtmlEditorHeader($event)"
            :startContent="''"
          />
        </div>

        <div class="flex">
          <div class="">
            <div class="datepickers input-container">
              <label style="margin-bottom: -3px">Od kiedy</label>
              <datepicker
                :monday-first="true"
                :language="pl"
                v-model="dateFrom"
                name="updateDate"
                :placeholder="'Wybierz datę'"
                required
              ></datepicker>
            </div>

            <div class="input-container datepickers">
              <label>Godzina aktualizacji</label>
              <vue-timepicker
                style="padding-left: 10px; font-size: 13px"
                format="HH:mm:ss"
                v-model="timeFrom"
              ></vue-timepicker>
            </div>
          </div>
          <div style="margin-left: 20px" class="">
            <div class="datepickers input-container">
              <label style="margin-bottom: -3px">Do kiedy</label>
              <datepicker
                :monday-first="true"
                :language="pl"
                v-model="dateTo"
                name="updateDate"
                :placeholder="'Wybierz datę'"
                required
              ></datepicker>
            </div>

            <div class="input-container datepickers">
              <label>Godzina aktualizacji</label>
              <vue-timepicker
                style="padding-left: 10px; font-size: 13px"
                format="HH:mm:ss"
                v-model="timeTo"
              ></vue-timepicker>
            </div>
          </div>
        </div>
        <div style="margin: 0; padding: 0">
          <p class="header-input">Checkboxy:</p>
          <div
            :id="`checkbox${index}content`"
            style="padding: 20px; margin-bottom: 40px"
            class="checkbox-container"
            v-for="(checkbox, index) in checkboxes"
            :key="`checkbox-${index}`"
          >
            <div class="input-container">
              <div class="flex">
                <div class="box">
                  <label class="priority" for="">Kolejność </label>
                  <select
                    @change="
                      checkIfPositionTaken(
                        checkbox.priority,
                        checkboxes.indexOf(checkbox)
                      )
                    "
                    v-model="checkbox.priority"
                    name=""
                    id=""
                  >
                    <option :value="p" v-for="p in priorities" :key="p">
                      {{ p }}
                    </option>
                  </select>
                </div>

                <button
                  type="button"
                  class="btn btn-danger delete-btn"
                  @click="removeCheckbox(checkbox, `checkbox${index}content`)"
                >
                  Usuń tego checkboxa
                </button>
              </div>

              <br />
              <br />
              <div class="input-container" style="margin-bottom: 20px">
                <label>Nagłówek checkboxa</label>

                <input
                  v-model="checkbox.description"
                  id="title"
                  type="text"
                  class="form-control"
                  required
                />
              </div>
              <label>Treść checkboxa</label>

              <html-editor
                :editorId="`checkbox${index}HtmlEditor`"
                @contentchanged="handleCheckboxEditor($event, index)"
                :startContent="''"
              />
            </div>

            <div class="input-container">
              <label>Wymagany do zaakceptowania?</label>
              <div class="radio-button">
                <input
                  v-model="checkbox.is_required"
                  :id="`is_required_${index}_yes`"
                  :value="true"
                  type="radio"
                  class="form-control"
                  required
                />
                <label :for="`is_required_${index}_yes`">Tak</label>
              </div>

              <div class="radio-button">
                <input
                  v-model="checkbox.is_required"
                  :id="`is_required_${index}_no`"
                  type="radio"
                  class="form-control"
                  required
                  :value="false"
                />
                <label :for="`is_required_${index}_no`">Nie</label>
              </div>
            </div>
          </div>
          <button
            class="btn btn-outline-dark add-next"
            @click="addNextFieldCheckbox()"
          >
            <span>{{
              checkboxes && checkboxes.length > 0
                ? "Dodaj kolejny checkbox"
                : "Dodaj checkbox"
            }}</span>
          </button>

          <p class="header-input">Partnerzy:</p>
          <div
            :id="`partners${index}content`"
            style="margin: 30px 0; padding: 30px"
            class="checkbox-container"
            v-for="(partner, index) in partners"
            :key="`partner-${index}`"
          >
            <div class="input-container">
              <button
                type="button"
                class="btn btn-danger"
                @click="removePartner(partner, `partners${index}content`)"
              >
                Usuń tego partnera
              </button>
              <br />
              <br />
              <label>Nazwa partnera</label>
              <input
                v-model="partner.name"
                id="title"
                type="text"
                class="form-control"
                required
              />
            </div>
          </div>
          <button
            class="btn btn-outline-dark add-next"
            @click="addNextFieldPartner()"
          >
            Dodaj kolejnego partnera
          </button>
        </div>

        <div>
          <button
            class="btn btn-outline-dark save-button"
            @click="saveNewModalWithCheckboxesAndPartners()"
          >
            Zapisz
          </button>
        </div>
      </div>

      <div v-if="!editingMode">
        <div class="added-modals">
          <h3 v-if="addedModals && addedModals.length > 0" class="my-4 py-4">
            Dodane modale
          </h3>

          <table
            class="table borderless"
            v-if="addedModals && addedModals.length > 0"
          >
            <thead>
              <tr class="tr-table">
                <th scope="col">ID</th>
                <th scope="col">Tytuł</th>
                <th scope="col">Nagłówek</th>
                <th scope="col">Data (od)</th>
                <th scope="col">Data (do)</th>
                <th scope="col">Checkboxy</th>
                <th scope="col">Partnerzy</th>
                <th scope="col">Edycja</th>
                <th scope="col">Usuwanie</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="modal in addedModals" :key="modal.id">
                <td>{{ modal.id }}</td>
                <td v-html="modal.title"></td>
                <td v-html="modal.header ? modal.header : `-`"></td>

                <td
                  v-html="
                    modal.update_date
                      ? modal.update_date.substring(0, 10) +
                        ' ' +
                        modal.update_date.substring(11, 19)
                      : `-`
                  "
                ></td>
                <td
                  v-html="
                    modal.to_update_date !== null
                      ? modal.to_update_date.substring(0, 10) +
                        ' ' +
                        modal.to_update_date.substring(11, 19)
                      : `-`
                  "
                ></td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    @click="showModalAddedCheckboxes(modal.checkboxes)"
                  >
                    Pokaż
                  </button>
                </td>

                <td>
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    @click="showModalAddedPartners(modal.partners)"
                  >
                    Pokaż
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    @click="editModal(modal)"
                  >
                    Edytuj
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="openDeleteConfirmModal(modal)"
                  >
                    Usuń
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="added-modals">
          <h3 class="my-4 py-4">Modal przy rejestracji</h3>

          <table class="table borderless" v-if="regulationModal">
            <thead>
              <tr class="tr-table">
                <th scope="col">ID</th>
                <th scope="col">Tytuł</th>
                <th scope="col">Nagłówek</th>
                <th scope="col">Data (od)</th>
                <th scope="col">Data (do)</th>
                <th scope="col">Checkboxy</th>
                <th scope="col">Partnerzy</th>
                <th scope="col">Edycja</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ regulationModal.id }}</td>
                <td v-html="regulationModal.title"></td>
                <td
                  v-html="regulationModal.header ? regulationModal.header : `-`"
                ></td>
                <td
                  v-html="
                    regulationModal.update_date
                      ? regulationModal.update_date
                      : `-`
                  "
                ></td>
                <td
                  v-html="
                    regulationModal.to_update_date !== null
                      ? regulationModal.to_update_date
                      : `-`
                  "
                ></td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    @click="
                      showModalAddedCheckboxes(regulationModal.checkboxes)
                    "
                  >
                    Pokaż
                  </button>
                </td>

                <td>
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    @click="showModalAddedPartners(regulationModal.partners)"
                  >
                    Pokaż
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    @click="editModal(regulationModal)"
                  >
                    Edytuj
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <modal
        name="addedCheckboxesModal"
        classes="app-modal"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="60%"
        height="auto"
      >
        <table class="table borderless">
          <thead>
            <tr class="tr-table">
              <th scope="col">ID</th>
              <th scope="col">Tekst</th>
              <th scope="col">Opis</th>
              <th scope="col">Czy jest wymagany</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="checkbox in modalAddedCheckboxes" :key="checkbox.id">
              <td>{{ checkbox.id }}</td>
              <td v-html="checkbox.text"></td>
              <td
                v-html="checkbox.description ? checkbox.description : '-'"
              ></td>
              <td>{{ checkbox.is_required ? "Tak" : "Nie" }}</td>
            </tr>
          </tbody>
        </table>
      </modal>

      <modal
        name="addedPartnerssModal"
        classes="app-modal"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="60%"
        height="auto"
      >
        <table class="table borderless">
          <thead>
            <tr class="tr-table">
              <th scope="col">ID</th>
              <th scope="col">Nazwa</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="partner in modalAddedPartners" :key="partner.id">
              <td v-if="!partner.is_deleted">{{ partner.id }}</td>
              <td v-if="!partner.is_deleted" v-html="partner.name"></td>
            </tr>
          </tbody>
        </table>
      </modal>

      <modal
        name="confirmDeleteModal"
        classes="app-modal"
        :min-width="200"
        :min-height="300"
        :scrollable="true"
        :reset="true"
        width="60%"
        styles="padding: 2rem; display: flex; flex-direction: column; justify-content: center; align-items: center"
      >
        <h3>
          Czy na pewno chcesz usunąć modal
          {{ modalToDelete ? modalToDelete.id : "" }}
        </h3>

        <div>
          <button type="button" class="btn btn-danger" @click="deleteModal()">
            Usuń
          </button>

          <button
            type="button"
            class="btn btn-outline-dark"
            @click="cancelDeleteModal()"
          >
            Anuluj
          </button>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import Datepicker from "vuejs-datepicker";
import axios from "../../axios";
import shared from "../../shared";
import { pl } from "vuejs-datepicker/dist/locale";
import HtmlEditor from "../../components/HtmlEditor.vue";
export default {
  components: { Datepicker, VueTimepicker, HtmlEditor },
  name: "ModalsManagement",
  data() {
    return {
      title: "",
      header: "",
      date: null,
      dateFrom: null,
      dateTo: null,
      checkboxes: [],
      partners: [],
      pl,
      time: "10:00:00",
      timeFrom: "10:00:00",
      timeTo: "10:00:00",
      addedModals: null,
      regulationModal: null,
      profileModal: null,
      modalAddedCheckboxes: [],
      modalAddedPartners: [],
      editingMode: false,
      modalToEdit: null,
      modalToDelete: null,
      trigger: true,
      selectedPicture: null,
      selectedPictureError: "",
    };
  },
  mounted() {
    this.fetchModals();
  },
  methods: {
    handleModalPicture(e) {
      e.preventDefault();
      const extension = e.target.files[0].name.split(".").pop();
      const availableFormats = ["svg", "png", "jpg", "jpeg"];
      if (!availableFormats.includes(extension.toLowerCase())) {
        this.selectedPictureError = `Niepoprawny format pliku. Dopuszczalne rozszerzenia to ${availableFormats.toString()}`;
        this.selectedPicture = null;
      } else {
        this.selectedPictureError = "";
        this.selectedPicture = e.target.files[0];
      }
    },
    removeCheckbox(checkboxToRemove, elementToHideId) {
      if (this.editingMode) {
        this.checkboxes.forEach((checkbox) => {
          if (checkbox.id === checkboxToRemove.id) checkbox.is_deleted = true;
        });
        this.trigger = true;
        const elementToHide = document.querySelector(`#${elementToHideId}`);
        elementToHide.style.height = "0px";
        elementToHide.style.display = "none";
      } else {
        this.checkboxes.splice(this.checkboxes.indexOf(checkboxToRemove), 1);
      }
    },

    removePartner(partnerToRemove, elementToHideId) {
      if (this.editingMode) {
        this.partners.forEach((partner) => {
          if (partner.name === partnerToRemove.name) partner.is_deleted = true;
        });
        const elementToHide = document.querySelector(`#${elementToHideId}`);
        elementToHide.style.height = "0px";
        elementToHide.style.display = "none";
      } else {
        this.partners.splice(this.partners.indexOf(partnerToRemove), 1);
      }
    },

    cancelEdition() {
      this.modalToEdit = null;
      this.editingMode = false;
      (this.title = ""),
        (this.header = ""),
        (this.date = null),
        this.time - "10:00:00",
        (this.checkboxes = []),
        (this.partners = []);
      this.selectedPicture = null;
      this.selectedPictureError = "";
      const editors = document.getElementsByClassName("ql-editor");
      if (editors) {
        editors.forEach((editor) => {
          editor.innerHTML = "";
        });
      }
    },
    cancelDeleteModal() {
      this.$modal.hide("confirmDeleteModal");
    },

    openDeleteConfirmModal(modal) {
      this.$modal.show("confirmDeleteModal");
      this.modalToDelete = modal;
    },

    async deleteModal() {
      if (this.modalToDelete) {
        await axios.delete(`/api/modalToDisplay/${this.modalToDelete.id}`);
        this.$notify({
          group: "success",
          text: "Modal został pomyślnie usunięty",
        });
        this.editingMode = false;
        this.modalToDelete = null;
        this.cancelDeleteModal();
        this.fetchModals();
      }
    },
    editModal(modal) {
      const editContentElement = document.querySelector(
        "#adding-modal-content"
      );
      editContentElement.scrollIntoView();
      const date = modal.update_date
        ? modal.update_date.substring(0, 10)
        : null;
      const time = modal.update_date
        ? modal.update_date.substring(10, 19).replace("T", "")
        : "10:00:00";
      const dateTo = modal.to_update_date
        ? modal.to_update_date.substring(0, 10)
        : null;
      const timeTo = modal.to_update_date
        ? modal.to_update_date.substring(10, 19).replace("T", "")
        : "10:00:00";
      this.dateFrom = date;
      this.timeFrom = time;
      this.dateTo = dateTo;
      this.timeTo = timeTo;
      this.modalToEdit = modal;
      this.title = modal.title;
      this.header = modal.subheader;
      this.checkboxes = modal.checkboxes.map((c) => {
        return {
          ...c,
          is_deleted: false,
        };
      });

      const titleHtmlEditor = document.querySelector("#titleHtmlEditor");
      const headerHtmlEditor = document.querySelector("#headerHtmlEditor");
      titleHtmlEditor.childNodes[2].childNodes[0].innerHTML = modal.title;
      headerHtmlEditor.childNodes[2].childNodes[0].innerHTML = modal.header;
      setTimeout(() => {
        modal.checkboxes.forEach((checkbox, index) => {
          const formattedTextForHtmlEditor = checkbox.text
            .replace(
              "<partners>Lista partnerów</partners>",
              "&lt;partners&gt;Lista partnerów&lt;/partners&gt;"
            )
            .replaceAll("<hide>", "&lt;hide&gt;");
          const checkboxHtmlEditor = document.querySelector(
            `#checkbox${index}HtmlEditor`
          );
          checkboxHtmlEditor.childNodes[2].childNodes[0].innerHTML =
            formattedTextForHtmlEditor;
        });
      }, 100);

      this.partners = modal.partners.map((p) => {
        return {
          ...p,
          is_deleted: false,
        };
      });
      this.editingMode = true;
    },
    showModalAddedCheckboxes(checkboxes) {
      this.modalAddedCheckboxes = checkboxes;
      this.$modal.show("addedCheckboxesModal");
    },
    showModalAddedPartners(partners) {
      this.modalAddedPartners = partners;
      this.$modal.show("addedPartnerssModal");
    },
    handleHtmlEditorTitle(content) {
      this.title = content;
    },
    handleHtmlEditorHeader(content) {
      this.header = content;
    },
    handleCheckboxEditor(content, checkboxIndex) {
      this.checkboxes[checkboxIndex].text = content;
    },
    addNextFieldCheckbox() {
      let allCheckboxesFilled = true;
      this.checkboxes.forEach((checkbox) => {
        if (!checkbox.text) {
          allCheckboxesFilled = false;
        }
      });
      if (allCheckboxesFilled) {
        this.checkboxes.push({
          text: "",
          is_required: false,
          description: "",
          priority: this.checkboxes.length + 1,
        });
      } else {
        this.$notify({
          group: "error",
          text: "Uzupełnij poprzednie checkboxy przed dodaniem kolejnego",
        });
      }
    },

    addNextFieldPartner() {
      let allPartnersFilled = true;
      this.partners.forEach((partner) => {
        if (!partner.name) {
          allPartnersFilled = false;
        }
      });
      if (allPartnersFilled) {
        this.partners.push({
          name: "",
        });
      } else {
        this.$notify({
          group: "error",
          text: "Uzupełnij poprzednich partnerów przed dodaniem kolejnego",
        });
      }
    },

    formatDateAndTimeToString() {
      return `${shared.dateWithoutTimeToString(this.dateFrom)}T${
        this.timeFrom
      }.000`;
    },
    formatDateAndTimeToStringTo() {
      return `${shared.dateWithoutTimeToString(this.dateTo)}T${
        this.timeTo
      }.000`;
    },

    async saveImageToModal(modalId) {
      if (modalId && this.selectedPicture) {
        try {
          const body = new FormData();
          body.append("image", this.selectedPicture);
          await axios.put(`/api/modalToDisplay/${modalId}/image`, body);
        } catch (error) {
          console.log(error);
        } finally {
          this.selectedPicture = null;
        }
      }
    },
    async saveNewModalWithCheckboxesAndPartners() {
      let flag = true;
      if (!this.title) {
        this.$notify({
          group: "error",
          text: "Wymagane podanie tytułu dla modala",
        });
        return;
      }

      if (!this.dateFrom || !this.timeFrom) {
        this.$notify({
          group: "error",
          text: "Wymagane wybranie daty oraz godziny, w której ma zostać wyświetlony modal",
        });
        return;
      }
      this.checkboxes.forEach((c) => {
        if (c.priority === "") {
          flag = false;
          this.$notify({
            group: "error",
            text: "Wymagane wybranie kolejności checkboxów",
          });
        }
      });
      if (!flag) return;

      const update_date = this.formatDateAndTimeToString();
      const update_date_to = this.formatDateAndTimeToStringTo();
      try {
        if (!this.editingMode) {
          const newModal = await axios.post("/api/modalToDisplay", {
            title: this.title,
            header: this.header,
            update_date: update_date,
            to_update_date: update_date_to,
            checkboxes: this.checkboxes.filter(
              (checkbox) => checkbox.text && checkbox.text != ""
            ),
            partners: this.partners.filter(
              (partner) => partner.name && partner.name != ""
            ),
          });
          console.log({
            modal: newModal.data,
          });
          console.log({
            id: newModal.data.id,
          });
          await this.saveImageToModal(newModal.data.id);
          this.fetchModals();
          this.$notify({
            group: "success",
            text: "Modal został pomyślnie zapisany",
          });
        }
        if (this.editingMode) {
          const editedModal = await axios.put(
            `/api/modalToDisplay/${this.modalToEdit.id}`,
            {
              title: this.title,
              header: this.header,
              update_date: update_date,
              to_update_date: update_date_to,
              checkboxes: this.checkboxes,
              partners: this.partners,
            }
          );
          await this.saveImageToModal(editedModal.data.id);
          this.fetchModals();
          this.$notify({
            group: "success",
            text: "Modal został pomyślnie zaktualizowany",
          });
          this.editingMode = false;
          this.modalToEdit = null;
        }

        (this.title = ""),
          (this.header = ""),
          (this.dateTo = null),
          this.timeTo - "10:00:00",
          (this.dateFrom = null),
          this.timeFrom - "10:00:00",
          (this.checkboxes = []),
          (this.partners = []);
        this.selectedPicture = null;
        this.selectedPictureError = "";
        const editors = document.getElementsByClassName("ql-editor");
        if (editors) {
          editors.forEach((editor) => {
            editor.innerHTML = "";
          });
        }
      } catch (error) {
        this.$notify({
          group: "error",
          text: "Nie udało się zapisać modala",
        });
      }
    },

    async fetchModals() {
      const response = await axios.get("/api/modalToDisplay/list");
      this.addedModals = response.data.modals;
      this.regulationModal = response.data.regulation_modal;
      this.profileModal = response.data.profile_modal;
    },
    checkIfPositionTaken(pos, index) {
      this.checkboxes.forEach((checkbox, i) => {
        if (this.editingMode) {
          if (
            !checkbox.is_deleted &&
            checkbox.priority === pos &&
            i !== index
          ) {
            //checkbox.priority = ''
            this.checkboxes[index].priority = "";
            this.$notify({
              group: "error",
              text: "Wybrana kolejność jest już zajęta",
            });
            return true;
          }
        } else {
          if (checkbox.priority === pos && i !== index) {
            //checkbox.priority = ''
            this.checkboxes[index].priority = "";
            this.$notify({
              group: "error",
              text: "Wybrana kolejność jest już zajęta",
            });
            return true;
          }
        }
      });
      return false;
    },
  },
  computed: {
    priorities() {
      let tmp = [];
      let i = 1;
      this.checkboxes.forEach((checkbox, index) => {
        if (this.editingMode && this.trigger) {
          if (!checkbox.is_deleted) {
            tmp.push(parseInt(i));
            i++;
          }
        } else {
          tmp.push(parseInt(index) + 1);
        }
      });
      return tmp;
    },
  },
};
</script>

<style scoped>
div {
  padding: 0;
  margin-top: 1rem;
}
.add-new-modal,
.added-modals {
  margin: 0 4rem;
}
.content {
  display: flex;
  /* border: 1px solid rgb(164, 158, 158); */
  border-radius: 5px;
  flex-wrap: wrap;
}

.datepickers {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.header-input {
  font-size: 16px;
  font-weight: 600;
  width: 320px;
  text-align: left;
  margin-top: 4rem;
  margin-bottom: 4rem;
  text-decoration: underline;
}
.radio-button {
  display: flex;
  align-items: center;
  height: 20px;
}
.radio-button input {
  width: 10px;
  display: flex;
  align-content: center;
  margin-right: 10px;
}
.radio-button label {
  margin: 0;
}
.add-next {
  width: 100%;
  margin: 1rem 0 0 0 !important;
}
td {
  vertical-align: middle;
}
.a {
}
.box select {
  background: #f7f8f9;
  color: #93a3ad;
  width: auto;
  border: none;
  min-width: 50px;
  font-size: 12px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
  -webkit-appearance: button;
  appearance: button;
  outline: none;
  height: 30px;
  padding-left: 10px;
  border-radius: 5px;
  margin: 0 15px 0 0;
  display: flex;
  flex-direction: column;
}
.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.delete-btn {
  margin-top: 40px;
  margin-left: 30px;
}
.priority {
  font-size: 14px;
}
.priority-number {
  color: #ec1a6b;
  cursor: pointer;
}
.checkbox-container {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.selected-picture-error {
  font-size: 15px;
  color: red;
  font-weight: 500;
}
</style>
